export const APPOINTMENT = 'Appointment';
export const CUSTOMER = 'Customer';
export const EXAM = 'Exam';
export const INVOICE = 'Invoice';
export const INVENTORY = 'Inventory';
export const WORK_ORDER = 'WorkOrder';
export const FORM = 'Form';
export const INTERNAL_FORM = 'InternalForm';
export const REVIEW = 'Review';
export const ONLINE_BOOKING = 'OnlineBooking';
export const SCHEDULE = 'Schedule';
export const BASIC_REPORT = 'BasicReport';
export const ADVANCED_REPORT = 'AdvancedReport';
export const INSIGHT = 'Insight';
export const TEMPLATE_CUSTOMIZATION = 'TemplateCustomization';